/**
 * @generated SignedSource<<16e941db80e1693bd1c5734a21b17945>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type eventosLoaderQuery$variables = {
  club: string;
};
export type eventosLoaderQuery$data = {
  readonly club: {
    readonly eventsEnabled: string | null | undefined;
  };
};
export type eventosLoaderQuery = {
  response: eventosLoaderQuery$data;
  variables: eventosLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": "eventsEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "EVENTS_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"EVENTS_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventosLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventosLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4c6f57a1687164599b056c9fe659664a",
    "id": null,
    "metadata": {},
    "name": "eventosLoaderQuery",
    "operationKind": "query",
    "text": "query eventosLoaderQuery(\n  $club: String!\n) {\n  club(slug: $club) {\n    eventsEnabled: configuration(key: \"EVENTS_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5294b46c29c908dca3eb08e80ca0d63e";

export default node;
